export default function DashboardVoting(){
  return (<div>
    Dashboard Voting
    </div>);
}